import React from 'react';
import { Link, useParams } from 'react-router-dom';

const SignECMR: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const workflowTarget = id ? `/workflow/${id}` : '/';

  return (
    <div className="container mx-auto p-4">
      <div className="bg-amber-100 border-l-4 border-amber-500 text-amber-800 p-6 rounded mb-4">
        <h1 className="text-2xl font-bold mb-3">Firma local no disponible en modo cloud-only</h1>
        <p className="mb-3">
          La captura manual de firmas en el navegador era un flujo local legacy. Para documentos e-CMR cloud-only,
          usa el flujo backend de procedimientos y firmas, que conserva la trazabilidad, roles, auditoría y evidencia
          en el sistema de registro autenticado.
        </p>
        <p className="mb-4">
          Esta pantalla no lee ni escribe documentos desde localStorage y no genera firmas locales de producción.
        </p>
        <Link
          to={workflowTarget}
          className="inline-block bg-indigo-600 hover:bg-indigo-700 text-white font-bold py-2 px-4 rounded"
        >
          Abrir flujo backend
        </Link>
      </div>
      <Link to="/" className="text-blue-700 hover:text-blue-900 underline">
        Volver a documentos cloud
      </Link>
    </div>
  );
};

export default SignECMR;
